// extracted by mini-css-extract-plugin
export default {"box":"styles_box__AEYc0","blue":"styles_blue__wUnuL","show":"styles_show__R73gs","borderShimmer":"styles_borderShimmer__A1xW1"};